const Data = [
 {
   "id": 1,
   "peopleid": 1,
   "name": "Lance Franklin",
   "club": "Sydney",
   "salary": "$1,450,000-$1.5 million",
   "bio": "The specifics of Franklin’s deal were made public after his shock decision to sign with the Swans, with the penultimate season of his contract reaching $1.5 million before dropping to $900,000 next year. He will have taken a small COVID cut to his wage this year. He is considered a certainty to play on again in 2022 and is closing in on becoming only the sixth man to kick 1000 goals. Hasn’t won a flag in his time with Sydney, but has been a hugely marketable force in a city that demands them.",
   "imagename": "Lance-Franklin",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 2,
   "peopleid": 2,
   "name": "Jeremy McGovern",
   "club": "West Coast",
   "salary": "$1.2-$1.25 million",
   "bio": "McGovern is footy’s best defender right now given four All Australian jumpers and his role in the Eagles’ 2018 premiership triumph. He signed his six-year deal on an average of $1.2 million a season and, although Eagles players took seven per cent pay cuts across the board this year, this is a year where his pay is back-ended so he is still on $1.2 million or even more. He has battled injury niggles all year, but at his best commands the skies above Optus Stadium with his intercept marking abilities. Contracted to 2024.",
   "imagename": "Jeremy-McGovern",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 3,
   "peopleid": 3,
   "name": "Dustin Martin",
   "club": "Richmond",
   "salary": "$1.2-$1.25 million",
   "bio": "Martin’s contract is likely second only to Lance Franklin given the $8.4 million total worth and he has arguably been under-paid given the spectacular achievements and marketing ability for the Tigers. How do you put a price on three Norm Smith Medals won during this deal? Martin recently turned 30, but due to his resilient body and fastidious maintenance program, he will surely have no issues fulfilling the next three years of the deal and then playing on into his late 30s.",
   "imagename": "Dustin-Martin",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 4,
   "peopleid": 4,
   "name": "Nat Fyfe",
   "club": "Fremantle",
   "salary": "$1,075,000-$1.1 million",
   "bio": "The Dockers signed-up Fyfe on a deal believed to be on an average of $1.1 million across the life of the contract. Like all players he has taken a pay cut this year. Despite injuries, the dual Brownlow Medallist has given Fremantle bang for their bucks as an inspirational club captain. The six-year deal signed in 2017 runs through to 2023 and is not back-ended, so the Dockers clearly have cash to burn, especially if Adam Cerra heads home.",
   "imagename": "Nat-Fyfe",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 5,
   "peopleid": 5,
   "name": "Brodie Grundy",
   "club": "Collingwood",
   "salary": "$925,000-$975,000",
   "bio": "Grundy’s much-debated seven-year contract has finally kicked in, putting him on an average of $1 million per season until the end of 2027. After a modest 2020, he returned to form earlier this season before neck issues cost him a few weeks on the sidelines. Some have questioned the length of his deal which came after his back-to-back Copeland Trophy and All-Australian seasons in 2018 and 2019. Only time will tell.",
   "imagename": "Brodie-Grundy",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 6,
   "peopleid": 6,
   "name": "Patrick Dangerfield",
   "club": "Geelong",
   "salary": "$900,000 - $950,000",
   "bio": "Has become the face of the Cats since his free agency move back home to Victoria. Played through the pain and restriction of a secret groin injury last year and is the obvious candidate to take over from Joel Selwood as captain if he hands over the skipper’s armband next year. Still one of the most influential stars in the game either midfield or forward. \n",
   "imagename": "Patrick-Dangerfield",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 7,
   "peopleid": 7,
   "name": "Patrick Cripps",
   "club": "Carlton",
   "salary": "$900,000 - $950,000",
   "bio": "The Blues skipper has accepted well under market rate to lock into a newly signed six-year deal with the club at around $750,000 per season from next year. His previous deal was on top dollar as he signed it in mid-2018 when he was 23 and on his way towards a second best-and-fairest and his first All-Australian blazer. But his salary sacrifice this time around ensures the Blues can still chase elite talent at the end of the season, with Fremantle’s Adam Cerra the No.1 target.",
   "imagename": "Patrick-Cripps",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 8,
   "peopleid": 8,
   "name": "Stephen Coniglio",
   "club": "GWS",
   "salary": "$900,000 - $950,000",
   "bio": "Carlton couldn’t have come any harder at Coniglio in 2019, but he recommitted to the Giants on a massive seven-year deal believed to be worth upwards of $1 million a season. Injuries (this year) and form (last year) blunted the 27-year-old captain’s impact. His deal runs through until the end of 2027. \n",
   "imagename": "Stephen-Coniglio",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 9,
   "peopleid": 9,
   "name": "Marcus Bontempelli",
   "club": "Western Bulldogs",
   "salary": "$900,000 - $950,000",
   "bio": "The Bulldogs’ skipper is in the final year of his current deal, with a new contract kicking in next season. He is currently having the best season of his already stunning AFL career and could cap it off with a Brownlow Medal and potentially a second premiership medal in September. His marketing capacity is strong.\n",
   "imagename": "Marcus-Bontempelli",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 10,
   "peopleid": 10,
   "name": "Jeremy Cameron",
   "club": "Geelong",
   "salary": "$850,000 - $900,000",
   "bio": "Some may have argued the Cats sold the farm for the Coleman medallist, but is there any doubt now the trade was worth it? Cameron has been red hot since returning from his double hamstring blow and is steering the Cats towards another deep finals finish. In almost career-best form and worth every penny.",
   "imagename": "Jeremy-Cameron",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 11,
   "peopleid": 11,
   "name": "Adam Treloar",
   "club": "Western Bulldogs",
   "salary": "$850,000 - $900,000",
   "bio": "Collingwood will contribute an average of $300,000 per season over the life of Treloar’s five-year deal. That will likely be around $275,000 in the first year and round out at about $325,000 in the last. He is locked away with the Bulldogs until the end of the 2025 season. As messy as his Pies’ exit was, he looks happy with his new club and is hoping to return from his ankle injury later in the season.\n",
   "imagename": "Adam-Treloar",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 12,
   "peopleid": 12,
   "name": "Rory Sloane",
   "club": "Adelaide",
   "salary": "$825,000-$875,000",
   "bio": "Sloane signed a five-year deal as a free agent in 2018 after massive conjecture about his future, with the deal taking him through to 2023.",
   "imagename": "Rory-Sloane",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 13,
   "peopleid": 13,
   "name": "Isaac Heeney",
   "club": "Sydney",
   "salary": "$825,000-$875,000",
   "bio": "As a 20-year-old, Heeney rejected monster offers from rival clubs, including North Melbourne, to remain loyal to the Swans in late 2016. As a consequence, he was rewarded with a big contract commensurate with his marketability and damaging play. Injuries have curtailed his impact at times, but he remains one of Sydney’s most important players.",
   "imagename": "Isaac-Heeney",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 14,
   "peopleid": 14,
   "name": "Christian Petracca",
   "club": "Melbourne",
   "salary": "$800,000-$850,000",
   "bio": "The superstar midfielder has become Melbourne’s highest-paid player following his exceptional 2020 breakout season when he announced himself as one of the game’s most lethal playmakers. The Demons did well this year to lock him away on a blockbuster seven-year contract worth about $900,000 a season which thwarted any hope rivals had of pinching him under free agency rules. It makes Petracca Melbourne’s marquee man for the prime part of his career.",
   "imagename": "Christian-Petracca",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 15,
   "peopleid": 15,
   "name": "Lachie Whitfield",
   "club": "GWS",
   "salary": "$800,000-$850,000",
   "bio": "Whitfield might be the best attacking half-back in the league at his best and he looms as a key figure in the Giants’ quest to play finals again. He stayed loyal when there were other suitors, signing a lucrative deal that runs through until the end of the 2027 season.",
   "imagename": "Lachie-Whitfield",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 16,
   "peopleid": 16,
   "name": "Toby Greene",
   "club": "GWS",
   "salary": "$800,000-$850,000",
   "bio": "Arguably the Giants’ most important player, he signed a six-year deal in 2018 and has added another two years onto that tying him to the club until the end of 2026. If he had returned to Melbourne, or was a little less injury prone, he would be a worthy $1 million man, as his top end stuff is simply sublime. A must-watch in any match.",
   "imagename": "Toby-Greene",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 17,
   "peopleid": 17,
   "name": "Josh Kelly",
   "club": "GWS",
   "salary": "$800,000-$850,000",
   "bio": "The silky-smooth Kelly has a big decision to make. Is he going to be a Giants’ “lifer”? Or is he going to return home to Victoria? He is nearing the end of the second year of his contract - meaning he can choose to recommit with GWS on a monster eight-year $1 million per season deal, or chase a new home. The Kangaroos are poised with purse strings at the ready. But have we heard this story before? Watch this space.\n",
   "imagename": "Josh-Kelly",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 18,
   "peopleid": 18,
   "name": "Max Gawn",
   "club": "Melbourne",
   "salary": "$800,000-$850,000",
   "bio": "Could be this year’s All-Australian captain after reclaiming the title as the game’s top ruckman throughout the first half of 2021. Signed a four-year contract extension earlier this year which rewards the superstar tall for his stellar consistency and leadership and provides long-term security after some significant knee worries early in his career. Has played a vital role in the Demons’ resurrection this year.",
   "imagename": "Max-Gawn",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 19,
   "peopleid": 19,
   "name": "Brad Hill",
   "club": "St Kilda",
   "salary": "$800,000-$850,000",
   "bio": "It was an interesting comment from St Kilda great Nick Riewoldt when he said some of the Saints’ star players had full bellies and weren’t dog hungry. Hill may fit into that category after the triple premiership Hawk came across from Fremantle on huge money and significant success from his time in brown and gold. Hasn’t had the impact he would have liked this season on the outside for a club which has been one of the biggest disappointments of the year.",
   "imagename": "Brad-Hill",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 20,
   "peopleid": 20,
   "name": "Joe Daniher",
   "club": "Brisbane",
   "salary": "$800,000-$850,000",
   "bio": "The Lions had to fork out the big bucks to land Daniher amid interest from Sydney and Geelong as well as Essendon in an effort to retain him. But it was late in the piece that Daniher’s TLA manager Tom Petroro informed the Lions he was headed to Queensland, securing the vital key forward the team was missing to round out their premiership tilt. It was smart to offer him $750,000 a year as it meant Essendon received a first-round pick as free agency compensation and meant Brisbane didn’t have to offer up multiple high draft picks in a trade.",
   "imagename": "Joe-Daniher",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 21,
   "peopleid": 21,
   "name": "Tom Mitchell",
   "club": "Hawthorn",
   "salary": "$800,000-$850,000",
   "bio": "Signed his latest contract on the back of a serious leg break which cost him the 2019 season. It ties the prolific ball magnet to the Hawks until the end of 2023, but Mitchell’s name has been raised as a trade target. While the Hawks have poured cold water on any potential move, they would be mad not to consider any serious or tempting offers for their senior stars to help strengthen their position in the first round of the next two drafts. The Hawks need top-end young talent to rejuvenate.\n",
   "imagename": "Tom-Mitchell",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 22,
   "peopleid": 22,
   "name": "Ollie Wines",
   "club": "Port Adelaide",
   "salary": "$800,000-$850,000",
   "bio": "Wines was due a huge figure well over $800,000 as part of a back-ended deal for 2021 and 2022 but has smoothed out that contract as part of a four-year extension that sees him locked away to 2026. It is remarkable to think he was so keen to get to Carlton - and the Blues baulked at the offer - given the way he has rebounded with such resounding form since then.",
   "imagename": "Ollie-Wines",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 23,
   "peopleid": 23,
   "name": "Zac Williams",
   "club": "Carlton",
   "salary": "$775,000-$825,000",
   "bio": "It’s been a rough initiation for the high-priced Blues recruit, with even his coach conceding fitness and form issues have led to a return to the backline from the midfield. Those close to the former Giant insist he is not on $900,000 per season, despite suggestions from one club that chased him hard last year. Half a season into his six-year deal, he is far from proving value for money in an already tight salary cap. A huge preseason looms as his chance to turn it all around.",
   "imagename": "Zac-Williams",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 24,
   "peopleid": 24,
   "name": "Jaeger O'Meara",
   "club": "Hawthorn",
   "salary": "$775,000-$825,000",
   "bio": "Came to Hawthorn to win a flag but will now help spearhead the club’s rebuild. Been a consistent midfielder after overcoming his career-threatening knee injuries which prompted his move from the Gold Coast. But it is unclear when O’Meara will play in his second final after breaking through in 2018 for the Hawks’ qualifying final loss to Richmond. The vice-captain has an important role to play in helping to groom the young Hawks over the next two years.",
   "imagename": "Jaeger-OMeara",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 25,
   "peopleid": 25,
   "name": "Jacob Weitering",
   "club": "Carlton",
   "salary": "$775,000-$825,000",
   "bio": "Now one of the best defenders in the game, Weitering signed a bumper new contract extension last August which takes him through until the end of the 2025 season. He franked that by winning the Blues’ 2020 best and fairest as well as continuing his impressive form into 2021, despite the club’s on-field woes.",
   "imagename": "Jacob-Weitering",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 26,
   "peopleid": 26,
   "name": "Luke Shuey",
   "club": "West Coast",
   "salary": "$775,000-$825,000",
   "bio": "Eagles skipper Shuey signed a four-year extension through to 2022 in 2017 only hours after the league ticked off on 20 per cent pay rises as part of a new collective bargaining agreement. He has barely put a foot wrong since, including the well-deserved Norm Smith Medal in 2018, and is finally on the charge back from long-running hamstring issues in the past year. \n",
   "imagename": "Luke-Shuey",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 27,
   "peopleid": 27,
   "name": "Darcy Moore",
   "club": "Collingwood",
   "salary": "$775,000-$825,000",
   "bio": "If only the Magpies had two Darcy Moores - to use at either end of the ground. The All-Australian defender locked in a two-year deal last October after his most consistent season to date. He is committed until the end of 2022, with Collingwood eager to secure him on a longer deal when the chance arises. He is one of the club’s most important players.",
   "imagename": "Darcy-Moore",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 28,
   "peopleid": 28,
   "name": "Lachie Neale",
   "club": "Brisbane",
   "salary": "$775,000-$825,000",
   "bio": "The Brownlow medallist deserves to be one of Brisbane’s two highest-paid players after a big-money move from Fremantle, worth about $4 million over 5 years. He’s the heartbeat of the Lions’ engine room and showed courage battling on bravely through a back ailment earlier this year. Fell out with some teammates in his last year at Fremantle, prompting the successful move to Brisbane. Astute get from the Lions, securing the man who rose to win the game’s top individual honour in 2020.",
   "imagename": "Lachie-Neale",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 29,
   "peopleid": 29,
   "name": "Andrew Gaff",
   "club": "West Coast",
   "salary": "$775,000-$825,000",
   "bio": "Gaff knocked back free agency last year with a minimum of fuss when he declined to take up a get-out clause in his contract to remain with the Eagles. His deal is believed to be up to $850,000 but he and his teammates took a seven per cent pay cut across the board as part of the league’s COVID cuts. The 29-year-old missed the flag with suspension but averages 20 games a season as a relentless, hard-running midfielder. Now the challenge is to hoist the premiership cup that eluded him in 2018.\n",
   "imagename": "Andrew-Gaff",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 30,
   "peopleid": 30,
   "name": "Elliot Yeo",
   "club": "West Coast",
   "salary": "$775,000-$825,000",
   "bio": "Yeo is on his way back from serious groin issues and will quickly reestablish himself as one of the league’s premier midfielders given his awesome CV. The 27-year-old was All Australian in 2017 and 2019 and won the club’s best-and-fairest in 2017 and 2018, completing an awesome three-season burst. The groin issues hit last year, but his five-year deal has him locked away at the Eagles until 2023.",
   "imagename": "Elliot-Yeo",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 31,
   "peopleid": 31,
   "name": "Dylan Shiel",
   "club": "Essendon",
   "salary": "$775,000-$825,000",
   "bio": "Will be interesting to see how the Bombers use Shiel when he returns from a serious knee injury given the rise of Darcy Parish and emergence of Nik Cox in his absence. Shiel arrived at Essendon as a big name on decent coin but the reality is he may now be their third-best midfielder in the new-look setup behind Zach Merrett and Parish. The challenge is to recapture his best form.",
   "imagename": "Dylan-Shiel",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 32,
   "peopleid": 32,
   "name": "Luke Parker",
   "club": "Sydney",
   "salary": "$775,000-$825,000",
   "bio": "The Swans’ free agent is negotiating a new deal with the club as his current five-year contract comes to an end. Now 28, Parker is heavily invested in Sydney’s future as one of the club’s co-skippers as well as having won two best and fairests and an All-Australian blazer.",
   "imagename": "Luke-Parker",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 33,
   "peopleid": 33,
   "name": "Clayton Oliver",
   "club": "Melbourne",
   "salary": "$750,000-$800,000",
   "bio": "Signed a two-year contract extension earlier this year which took him off Carlton’s radar and keeps him in red and blue until 2023 when he hits free agency. While this deal puts him in the top few earners at Melbourne, his next contract could be a doozy if interest remains high. He’s become an even better onballer this year at Melbourne and will help spearhead the Dees’ shot at a drought-breaking flag\n",
   "imagename": "Clayton-Oliver",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 34,
   "peopleid": 34,
   "name": "Trent Cotchin",
   "club": "Richmond",
   "salary": "$750,000-$800,000",
   "bio": "Cotchin extended his deal in 2018 to add another two seasons and has continued his remarkable trajectory as a defence-minded midfielder who has led the Tigers mightily despite the turbulence of hub-life. Despite accepting he will miss games due to hamstrings that occasionally fail him, he is keen to play deep into his 30s, having turned 31 in April.",
   "imagename": "Trent-Cotchin",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 35,
   "peopleid": 35,
   "name": "David Swallow",
   "club": "Gold Coast",
   "salary": "$750,000-$800,000",
   "bio": "Swallow might never have quite reached the heights he promised as an explosive No.1 pick, but his loyalty to the Gold Coast has stood out like a beacon. He signed a five-year extension in 2018 when everyone else was jumping ship and his deal is believed to be just under $800,000 in 2021. He is only 28 but would be losing some hope he can play in that elusive first final given the Suns’ continuing issues.",
   "imagename": "David-Swallow",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 36,
   "peopleid": 36,
   "name": "Tim Kelly",
   "club": "West Coast",
   "salary": "$750,000-$800,000",
   "bio": "Kelly signed a six-season contract at the end of 2019 with West Coast after his management brokered a deal to get him and his family home. He was finally showing exactly why he was worth - nearly $800,000 a season - before a recent knee injury, but at his best the hard-running mid is exactly what the Eagles need. We are yet to see the full Eagles midfield package of Nic Nat-Yeo-Kelly-Shuey at their best, but it is a scary proposition.\n",
   "imagename": "Tim-Kelly",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 37,
   "peopleid": 37,
   "name": "Jack Darling",
   "club": "West Coast",
   "salary": "$750,000-$800,000",
   "bio": "Darling is well on his way to a 500-goal career, at times thrusting his name forward as the game’s most lethal forward but always contributing to what is now a trio of star talls alongside Oscar Allan and Josh Kennedy, who might be the best bargain in the league given he has often played for less than his true market value. Darling has seven seasons of at least 39 goals and is still only 29 years of age.",
   "imagename": "Jack-Darling",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 38,
   "peopleid": 38,
   "name": "Aaron Naughton",
   "club": "Western Bulldogs",
   "salary": "$725,000-$775,000",
   "bio": "The Bulldogs put the go-home factor to bed early by locking in the high-flying key forward from WA on a four-year extension way back in 2019. It was a strategic move and the upside for the Bulldogs is that Naughton is now secure until at least the end of 2024 and looks set to play a huge role in their future plans.",
   "imagename": "Aaron-Naughton",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 39,
   "peopleid": 39,
   "name": "Jordan De Goey",
   "club": "Collingwood",
   "salary": "$700,000-$750,000",
   "bio": "De Goey’s two-year deal with the Magpies - which runs until the end of next season - was brokered by his father. In many ways, he was paid on potential and will need to show greater consistency to secure a bigger deal next time around. His best is good enough, but he needs to start producing more to justify his pay scale. Does he stay with the Magpies or chase free agency? It will be a fascinating watch.",
   "imagename": "Jordan-De-Goey",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 40,
   "peopleid": 40,
   "name": "Steven May",
   "club": "Melbourne",
   "salary": "$700,000-$750,000",
   "bio": "There might have been some hiccups in his first season at Melbourne but there is no question the May trade has been an excellent move. One of the most dominant defenders in the competition and a huge key to their premiership hopes, there will be outrage if May doesn’t claim his first All-Australian jumper.",
   "imagename": "Steven-May",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 41,
   "peopleid": 41,
   "name": "Mitch Duncan",
   "club": "Geelong",
   "salary": "$700,000-$750,000",
   "bio": "Would have been high up in Norm Smith Medal contention in last year’s Grand Final before the Dustin Martin second-half takeover. One of the best field kicks in the competition who poses a constant threat in the forward half. May not have some of the accolades as some of his Geelong teammates but he has been rewarded in his contracts for his loyalty to the club after turning down offers from the two Western Australian clubs.",
   "imagename": "Mitch-Duncan",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 42,
   "peopleid": 42,
   "name": "Jack Macrae",
   "club": "Western Bulldogs",
   "salary": "$700,000-$750,000",
   "bio": "Star midfielder who isn’t quite on the same pay scale as his captain, but is still on very good coin, even if he could have potentially earned more elsewhere. He is locked away until the end of 2022 after securing an extension four years ago, and is one of the Dogs’ best players.",
   "imagename": "Jack-Macrae",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 43,
   "peopleid": 43,
   "name": "Jack Riewoldt",
   "club": "Richmond",
   "salary": "$700,000-$750,000",
   "bio": "Riewoldt turns 33 in October and keeps delivering. Every time he is questioned he bounces back with a game-turning performance. Well paid across his career as a three-time premiership winner and three-time Coleman Medallist, he took a pay cut in 2018 to add another two years to his deal and has in recent weeks agreed to terms for 2022. With Riewoldt hitting 700 goals in the 2021 season he will set his sights on more premiership glory with his AFL legacy already firmly established.",
   "imagename": "Jack-Riewoldt",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 44,
   "peopleid": 44,
   "name": "Charlie Cameron",
   "club": "Brisbane",
   "salary": "$700,000-$750,000",
   "bio": "Was in high demand last year when the electric small forward signed a bumper five-year contract extension, ensuring he will play out his career at Brisbane. While there have been some form dips, the goal kicker is one of the keys to the club’s attempts to go all the way under Chris Fagan. The speedster was another savvy pickup for the Lions and puts bums on seats as well as kick goals.",
   "imagename": "Charlie-Cameron",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 45,
   "peopleid": 45,
   "name": "Harris Andrews",
   "club": "Brisbane",
   "salary": "$700,000-$750,000",
   "bio": "One of the best key defenders in the AFL who signed a bumper five-year contract last year. It ties the star bookend to the club until the end of 2025 and locks in a man widely tipped to become the club’s next captain. Only 24, Andrews will earn his money trying to shut down the opposition’s best forwards each week.",
   "imagename": "Harris-Andrews",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 46,
   "peopleid": 46,
   "name": "Jack Steele",
   "club": "St Kilda",
   "salary": "$700,000-$750,000",
   "bio": "Has certainly earned his pay cheque this year as a shining light in a St Kilda midfield unit which has been well-beaten at times this year. Steele emerged as one of the competition’s top-line onballers last year and signed a juicy contract towards the back end of the season which included a hefty pay rise as he took out All-Australian and best and fairest honours. Great move by the Saints to poach him from GWS Giants.",
   "imagename": "Jack-Steele",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 47,
   "peopleid": 47,
   "name": "Dane Rampe",
   "club": "Sydney",
   "salary": "$700,000-$750,000",
   "bio": "Even at 31, Rampe remains one of the most versatile and lively defenders in the competition. He still has another year to run on his current deal - taking him through to the end of 2022 - before a likely pay cut would help to ease some of the Swans’ cap issues.",
   "imagename": "Dane-Rampe",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 48,
   "peopleid": 48,
   "name": "James Sicily",
   "club": "Hawthorn",
   "salary": "$700,000-$750,000",
   "bio": "Was in the All-Australian conversation two years in a row before suffering a season-ending knee reconstruction last August. Was one of the best intercepting defenders in the competition and the Hawks hope his serious knee injury doesn’t mess with his intercept marking and lateral movement. Should be one of the highest paid players at Hawthorn for the next five years regardless. A match-winner who can dominate at both ends.",
   "imagename": "James-Sicily",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 49,
   "peopleid": 49,
   "name": "Chad Wingard",
   "club": "Hawthorn",
   "salary": "$700,000-$750,000",
   "bio": "The Hawks may have erred in swapping a first-round pick and Ryan Burton for Wingard to help top-up for another premiership tilt. Nothing against Wingard, but the Hawks may have thought they were closer to their next flag than they actually were. That said, Wingard has provided some electricity and polish in the forward half and deserves credit for finishing third in the best and fairest last year after missing the top-10 from 14 games in 2019. About to turn 28 so still plenty of good footy ahead of him.",
   "imagename": "Chad-Wingard",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 50,
   "peopleid": 50,
   "name": "Scott Pendlebury",
   "club": "Collingwood",
   "salary": "$700,000-$750,000",
   "bio": "Has been Collingwood's best and most consistent performer for more than a decade. The skipper has always been well compensated but has more than justified his wage over the years. Still a crucial player for the Magpies, despite being 33, as evidenced by his best afield performance against Melbourne. Has indicated he wants to play on for as long as he can.",
   "imagename": "Scott-Pendlebury",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 51,
   "peopleid": 51,
   "name": "Mitch McGovern",
   "club": "Carlton",
   "salary": "$700,000-$750,000",
   "bio": "The Blues were struggling to attract key players and desperately needed a forward in late 2018 when they carved off five seasons and a large slice of their salary cap for McGovern. It was a gamble that hasn’t yet worked. He was super fit over summer but injuries held him back again. He still has two more seasons at around $750,000 per season to play out on a salary cap that is already being squeezed. Needs to get his body right.",
   "imagename": "Mitch-McGovern",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 52,
   "peopleid": 52,
   "name": "Ben Cunnington",
   "club": "North Melbourne",
   "salary": "$700,000-$750,000",
   "bio": "He might be the Kangaroos’ highest paid player, but the contested hard nut has never been one to want to bring attention to himself. He could have asked for more at the time of his last deal, but opted to take a little less. Cunnington remains committed to the Kangaroos until the end of 2022, after signing a three-year deal in the middle of 2019.",
   "imagename": "Ben-Cunnington",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 53,
   "peopleid": 53,
   "name": "Jared Polec",
   "club": "North Melbourne",
   "salary": "$700,000-$750,000",
   "bio": "This is a deal that the Kangaroos would love to get off the books. Desperate to attract talent at the end of 2018, they offered Polec considerable overs in money and tenure to lure him across from Port Adelaide. It hasn’t worked. The five-year deal, at around $700,000 per season, runs through until the end of 2023. They couldn’t find a suitor for him last season. Has managed only three games so far this year and is currently out with a hamstring injury.",
   "imagename": "Jared-Polec",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 54,
   "peopleid": 54,
   "name": "Rory Laird",
   "club": "Adelaide",
   "salary": "$675,000-$725,000",
   "bio": "Laird is a dual All Australian defender who has now made a real splash as a rover for the Crows, having this year signed a five-year deal through to the end of 2026. Laird would have been a free agent this year, which gave him more leverage in contract talks. But instead he signed on to be a critical part of the club’s resurgence under new coach Matthew Nicks.",
   "imagename": "Rory-Laird",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 55,
   "peopleid": 55,
   "name": "Matt Crouch",
   "club": "Adelaide",
   "salary": "$675,000-$725,000",
   "bio": "Crouch is in the final year of a three-year deal signed as he was an All Australian and club champion that saw him record the most possessions of any player in 2017. \nHe hasn’t played due to a groin injury this year with significant conjecture about what he is worth, but he signed at the top of the market.",
   "imagename": "Matt-Crouch",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 56,
   "peopleid": 56,
   "name": "Charlie Curnow",
   "club": "Carlton",
   "salary": "$675,000-$725,000",
   "bio": "Garry Lyon questioned whether Carlton paid “overs” for Curnow in mid-2018 when the power-forward signed a lucrative long-term deal when he appeared on the cusp of stardom. A series of knee injuries and setbacks have meant he hasn’t played a senior game since mid-2019. He is eyeing a return and still has two more seasons to run on his current deal. Imagine if he can start combining with Harry McKay.",
   "imagename": "Charlie-Curnow",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 57,
   "peopleid": 57,
   "name": "Jack Billings",
   "club": "St Kilda",
   "salary": "$675,000-$725,000",
   "bio": "Big chance he changes teams next season as the Saints aren’t exactly banging down the door with another big contract. The goalkicking midfielder signed a lucrative contract in 2019 for two years but the Saints seem reluctant to hand over big dollars this time. He’s a nice finisher, but he finished outside the top-10 of the best and fairest last year from 13 games after placing fourth in 2019.",
   "imagename": "Jack-Billings",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 58,
   "peopleid": 58,
   "name": "Rory Lobb",
   "club": "Fremantle",
   "salary": "$675,000-$725,000",
   "bio": "Lobb has always been well paid as a high-marking key forward equally adept at pushing into the ruck, despite never quite living up to the hype at GWS or Fremantle. He has another season left on the four-year deal he signed at the end of 2018 to cross to Fremantle. At only 28 the Dockers will be desperately hoping his best football is still ahead of him after he didn’t feature in the top 10 in the best-and-fairest last year despite playing all 17 games.",
   "imagename": "Rory-Lobb",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 59,
   "peopleid": 59,
   "name": "Dion Prestia",
   "club": "Richmond",
   "salary": "$675,000-$725,000",
   "bio": "One of Richmond’s best finals performers continues to drive Richmond to excellence, his move to the Tigers justified many times over. They handed over a top-10 pick but he and his management knew the Tigers midfield could be something special when he moved to the Tigers despite their horror 2016 season. Prestia signed a new three-year locking him in until 2024 at the start of 2021.\n",
   "imagename": "Dion-Prestia",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 60,
   "peopleid": 60,
   "name": "Jack Ziebell",
   "club": "North Melbourne",
   "salary": "$675,000-$725,000",
   "bio": "The Kangaroos' skipper was at the top of his game when he signed a five-year contract extension in 2015. The deal runs out at the end of this season, which will free up some room in the club’s salary cap. He has remained loyal to North Melbourne and wants to play on into his 30s.",
   "imagename": "Jack-Ziebell",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 61,
   "peopleid": 61,
   "name": "Tom McDonald",
   "club": "Melbourne",
   "salary": "$675,000-$725,000",
   "bio": "It has been an extraordinary career turnaround for a man who Melbourne tried unsuccessfully to ship-off last year in part because of his significant salary. Greater Western Sydney considered it and Collingwood would have loved to have been able to afford him. But McDonald was outstanding in the early part of this season and has re-established himself as the spearhead of the attack, despite pressure from Ben Brown and Sam Weideman for his spot.",
   "imagename": "Tom-McDonald",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 62,
   "peopleid": 62,
   "name": "Taylor Adams",
   "club": "Collingwood",
   "salary": "$675,000-$725,000",
   "bio": "Signed a five-year deal midway through 2019, choosing security and tenure over maximum dollars. Looms as the potential next captain of the club beyond Pendlebury. Just needs to get on top of the injury issues that have frustrated him in recent seasons. Will be an important player in the reshaping of Collingwood’s list.",
   "imagename": "Taylor-Adams",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 63,
   "peopleid": 63,
   "name": "Tim English",
   "club": "Western Bulldogs",
   "salary": "$650,000-$700,000",
   "bio": "One of the AFL’s most exciting young ruckmen, English was a priority signing for the Bulldogs in 2019 when he recommitted until the end of 2022. Has continued to develop in this time and looks ready for a long and successful career in red, white and blue.",
   "imagename": "Tim-English",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 64,
   "peopleid": 64,
   "name": "Tim Taranto",
   "club": "GWS",
   "salary": "$650,000-$700,000",
   "bio": "At only 23, this bloke is already a leader, coming of age with a huge finals campaign in 2019, including a strong Grand Final appearance. When he first arrived at the club some predicted he might be quick to leave the joint, but he has not only stayed, he loves the place. Comes out of contract at the end of next year, but the Giants are confident he will recommit again.",
   "imagename": "Tim-Taranto",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 65,
   "peopleid": 65,
   "name": "Steele Sidebottom",
   "club": "Collingwood",
   "salary": "$650,000-$700,000",
   "bio": "Has been one of the AFL’s smoothest movers for many years, Sidebottom is coming off two frustrating seasons where injury and form dulled his impact. Has always provided great bang for his buck, but has faced some rare form challenges this year. Remains contracted until the end of 2022. Could he find a more permanent spot in attack where he has always had an uncanny goal sense?",
   "imagename": "Steele-Sidebottom",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 66,
   "peopleid": 66,
   "name": "Taylor Walker",
   "club": "Adelaide",
   "salary": "$650,000-$700,000",
   "bio": "Walker is still well paid given he is in the last year of a deal signed in 2017 when he was in the form of his life and also voted the best captain in the league the previous season.\nWhile he will take a pay cut next year to play on, he has justified the new deal signed this week, given his strong service to the Crows.\n",
   "imagename": "Taylor-Walker",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 67,
   "peopleid": 67,
   "name": "Zach Merrett",
   "club": "Essendon",
   "salary": "$650,000-$700,000",
   "bio": "Signed a six-year contract worth $800,000 to $850,000 starting next season to help lead the young Bombers back up the ladder. It was a huge show of faith from the pick No.26 who looked gone six months ago when other clubs flagged strong interest. But the significant turnaround on and off-field won his signature in a massive coup for the club. He will be well-paid, but Essendon didn’t have to pay silly money to keep him.",
   "imagename": "Zach-Merrett",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 68,
   "peopleid": 68,
   "name": "Dyson Heppell",
   "club": "Essendon",
   "salary": "$650,000-$700,000",
   "bio": "Has been extremely selfless, signing modest contracts on his past two deals with the Bombers, but that won’t surprise anyone at Tullamarine. Could have pressed Essendon for more money on the back of the supplements saga, but he left some on the table to help secure and keep other players in recent years. Having a fantastic season across half-back and on track to finish high up in the best and fairest.",
   "imagename": "Dyson-Heppell",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 69,
   "peopleid": 69,
   "name": "Jake Lever",
   "club": "Melbourne",
   "salary": "$650,000-$700,000",
   "bio": "Signed a new deal last year to extend his terms at the Demons. It meant he wasn’t on mega bucks, but like May, Lever has recaptured his best form this year and is in the mix for All-Australian honours. The big investment in the defensive setup has paid off.",
   "imagename": "Jake-Lever",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 70,
   "peopleid": 70,
   "name": "Michael Hurley",
   "club": "Essendon",
   "salary": "$650,000-$700,000",
   "bio": "This season has been a write-off for the defender who contracted a serious blood infection, leaving the veteran backman bed-ridden for a month. The Bombers have said repeatedly his health has been the priority as he attempts to regain weight and fitness in preparation for preseason. Contracted for one more year after Essendon fought off Western Bulldogs for his prized signature in 2016.",
   "imagename": "Michael-Hurley",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 71,
   "peopleid": 71,
   "name": "Michael Walters",
   "club": "Fremantle",
   "salary": "$650,000-$700,000",
   "bio": "Walters has proved himself one of the most loyal and accomplished Dockers, signing a two-year extension through to 2022 in 2018 on around $700,000 a season. It is understood he has quietly extended that deal by at least a year and as the five-time leading goalkicker at Fremantle and a 2019 All Australian the 30-year-old will be desperate to hang on for many years as the young and exciting Dockers enter their own finals window.",
   "imagename": "Michael-Walters",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 72,
   "peopleid": 72,
   "name": "Jarrod Witts",
   "club": "Gold Coast",
   "salary": "$650,000-$700,000",
   "bio": "Witts’ move from Collingwood to Gold Coast has been a spectacular success with the inconsistent Pie turning into a stalwart and club leader at Gold Coast before this year’s untimely ACL injury. Witts signed a new long-term deal across five seasons in 2019 that should set him up financially, with the contract running through to 2024. He might not be the AFL’s most high-profile captain but the Suns love his quiet brand of leadership.",
   "imagename": "Jarrod-Witts",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 73,
   "peopleid": 73,
   "name": "Adam Saad",
   "club": "Carlton",
   "salary": "$625,000-$675,000",
   "bio": "The rebounding half-back made the move from Essendon to Carlton last off-season for role reasons as much as money, though he is being well compensated at the Blues. He has been a solid performer in his first season at the club in difficult circumstances, with his deal running through to the end of 2025.",
   "imagename": "Adam-Saad",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 74,
   "peopleid": 74,
   "name": "Ben King",
   "club": "Gold Coast",
   "salary": "$625,000-$675,000",
   "bio": "King is the highest-paid third year player in the league and he is worth every dollar. Despite speculation of a deal for his third and fourth years that had him earning up to $800,000, it is understood his deal for a third year is just on $650,000. The Suns had to pay up to keep him and would be thrilled at his huge output in a struggling side. He is contracted to 2022 but the Suns won’t commence talks on a new deal until the end of the year. Brother Max has re-signed at St Kilda but those close to them believe they could play well together in the same side.",
   "imagename": "Ben-King",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 75,
   "peopleid": 75,
   "name": "Scott Lycett",
   "club": "Port Adelaide",
   "salary": "$625,000-$675,000",
   "bio": "Lycett cashed in on his free agency as a West Coast premiership ruckman at the end of 2018 and his best is still exceptional despite some injury issues, with the hard-tackling ruckman mid-way through a deal that is just a tick over $3 million for the life of the contract. As is so often the case players extract a premium for their free agency given their new side doesn't have to hand over a draft pick.",
   "imagename": "Scott-Lycett",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 76,
   "peopleid": 76,
   "name": "Jade Gresham",
   "club": "St Kilda",
   "salary": "$625,000-$675,000",
   "bio": "Been cruelled by injury over the past 12 months with a stress fracture in his back and then an achilles setback early in 2021. At his best, Gresham is one of the Saints’ most skilful and exciting forward half players and they’ve sorely missed his burst and nous around goals this season. Signed a four-year deal which locks him away until 2023.",
   "imagename": "Jade-Gresham",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 77,
   "peopleid": 77,
   "name": "Dan Hannebery",
   "club": "St Kilda",
   "salary": "$625,000-$675,000",
   "bio": "Hannebery’s career has been stuck at the crossroads all season, with the former Sydney midfielder unable to get out on to the park after another string of soft-tissue problems. The Saints have tried to mix up his rehabilitation program without success. Expect there to be serious talks about whether he wants to go on next year and what sort of settlement could be required. Sadly, the move hasn’t worked.",
   "imagename": "Dan-Hannebery",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 78,
   "peopleid": 78,
   "name": "Hugh McCluggage",
   "club": "Brisbane",
   "salary": "$625,000-$675,000",
   "bio": "Signed a big contract extension at the start of this season which included a decent pay rise to match his rise in the competition. The No. 3 draft pick has been a major factor in Brisbane’s rebuild, becoming one of the most damaging and consistent wingmen in the league. He has been talked about as a future Brownlow medallist and is so clean and assured with his run-and-carry outside midfield game. Would have been one of the most sought-after players in the game if he hadn’t recommitted until 2024.",
   "imagename": "Hugh-McCluggage",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 79,
   "peopleid": 79,
   "name": "Brad Crouch",
   "club": "St Kilda",
   "salary": "$625,000-$675,000",
   "bio": "The Saints didn’t overpay to land Brad Crouch from Adelaide amid only mild interest from rival clubs. It is why the Crows didn't receive a first-round compensation pick in the free agency move last year. It’s flown under the radar, but he’s had a solid first half of the season with St Kilda and has proven to be durable, despite his injury issues at Adelaide. But we can safely expect changes to the engine room for next year.",
   "imagename": "Brad-Crouch",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 80,
   "peopleid": 80,
   "name": "Nic Naitanui",
   "club": "West Coast",
   "salary": "$600,000-$650,000",
   "bio": "Naitanui has at times been the highest-paid player at West Coast but has played for unders in the last few years given his injury issues and spectacular off-field marketability and capacity to earn cash away from the club. You could argue he is under-paid by several hundred thousand dollars but it’s a selfless move from a player who has massive earning potential even after his AFL career.",
   "imagename": "Nic-Naitanui",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 81,
   "peopleid": 81,
   "name": "Daniel Talia",
   "club": "Adelaide",
   "salary": "$600,000-$650,000",
   "bio": "Talia signed a significant five-year deal as a Rising Star winner and All Australian who had gained a reputation as one of footy’s most miserly defenders. With that deal expiring this year he can expect to take a hefty pay cut after a tough year that has seen him sidelined with foot surgery.\n",
   "imagename": "Daniel-Talia",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 82,
   "peopleid": 82,
   "name": "Tom Hawkins",
   "club": "Geelong",
   "salary": "$600,000-$650,000",
   "bio": "Is putting together another exceptional season which sees the superstar goal kicker heading towards a fourth All-Australian jumper. He is in great physical condition, creating goals with his ruck work on top of his obvious class and marking power. Kicked at least one goal in every game this season and is renowned for his selflessness. A champion forward.",
   "imagename": "Tom-Hawkins",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 83,
   "peopleid": 83,
   "name": "Cameron Guthrie",
   "club": "Geelong",
   "salary": "$600,000-$650,000",
   "bio": "The no-frills onballer has picked up where he left off last season when he stamped himself as an A-Grade midfielder. Guthrie, who remains without a contract for next year, won All-Australian and best and fairest honours in 2020 and has been arguably even more important this year when Dangerfield went down. Tough and reliable, expect Guthrie to sign the biggest deal of his life on his next contract in reward for his stellar form.",
   "imagename": "Cameron-Guthrie",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 84,
   "peopleid": 84,
   "name": "Jack Viney",
   "club": "Melbourne",
   "salary": "$600,000-$650,000",
   "bio": "Geelong had some interest late last year which would have driven up his price at the pointy end of his contract talks. But it was the extra security in the form of a five-year contract that was more important to Viney after some major foot issues in recent years, including another flare-up last month. The Demons have made mistakes on this front in the past and have vowed to be more cautious. Such an important player for the pressure he puts on.",
   "imagename": "Jack-Viney",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 85,
   "peopleid": 85,
   "name": "Jake Lloyd",
   "club": "Sydney",
   "salary": "$600,000-$650,000",
   "bio": "The Sydney defender was heavily courted by Gold Coast before accepting around $150,000 less to stay with the Swans when he signed a four-year contract extension in late 2018. He has won two best-and-fairests since putting pen to paper. Perhaps a little underpaid, given his output, but he is happy to play his important role within the team.",
   "imagename": "Jake-Lloyd",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 86,
   "peopleid": 86,
   "name": "Tom Papley",
   "club": "Sydney",
   "salary": "$600,000-$650,000",
   "bio": "Looks as invested as ever after declaring he wants to remain a Swan for life. He signed a long-term deal with Sydney which tied him to the club until the end of 2023. However, he unsuccessfully sought a trade to Carlton at the end of 2019. That seems long gone now, and he is happy at the Swans and playing a significant role in the club’s push for the finals.",
   "imagename": "Tom-Papley",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 87,
   "peopleid": 87,
   "name": "Callum Mills",
   "club": "Sydney",
   "salary": "$600,000-$650,000",
   "bio": "Has been relatively well paid since winning the 2016 Rising Star award, signing a five-year deal with the Swans that runs through until the end of the 2023 season. Has moved into a midfield role this season after playing much of his early AFL career in defence.",
   "imagename": "Callum-Mills",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 88,
   "peopleid": 88,
   "name": "Christian Salem",
   "club": "Melbourne",
   "salary": "$600,000-$650,000",
   "bio": "Doesn’t get the same adulation and recognition as some of his midfield teammates but the drive and polish he provides across half back can’t be understated. Aside from Christian Petracca, Salem is the Dees’ best ball-user. Going nowhere after inking a five-year deal on good money.",
   "imagename": "Christian-Salem",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 89,
   "peopleid": 89,
   "name": "Andrew McGrath",
   "club": "Essendon",
   "salary": "$600,000-$650,000",
   "bio": "Made the big call to stay at Essendon when the sky was falling and a trio of other stars departed at the end of 2020. It is that sort of commitment, along with his speed and polish through the middle that have many tipping McGrath to become a future captain. Was taken with pick No. 1 and although he started out his career in defence, the Bombers always saw him as a blue-chip midfielder.",
   "imagename": "Andrew-McGrath",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 90,
   "peopleid": 90,
   "name": "Cale Hooker",
   "club": "Essendon",
   "salary": "$600,000-$650,000",
   "bio": "Has been one of the surprise packets of the season, proving a quality marking target deep in attack after battling some back and hip issues in recent years. Hooker has made quite a comeback in 2021 as part of a potent offence. Signed a monster five-year deal in 2016 when Fremantle chased him hard and the final years of that deal ensures he is on a good wicket.",
   "imagename": "Cale-Hooker",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 91,
   "peopleid": 91,
   "name": "Sam Docherty",
   "club": "Carlton",
   "salary": "$600,000-$650,000",
   "bio": "Carlton extended its co-captain’s contract at the end of last season, following his heart-warming return to AFL football after missing two years with knee reconstructions. Like a number of his teammates, he has struggled to recapture his best form this season. But he remains locked into the Blues until the end of 2023.",
   "imagename": "Sam-Docherty",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 92,
   "peopleid": 92,
   "name": "Travis Boak",
   "club": "Port Adelaide",
   "salary": "$600,000-$650,000",
   "bio": "Boak agreed to a new two-year extension at the start of 2020 after a spectacular 2019 season that saw him win the club’s best-and-fairest. Despite his form Boak chose security over the absolute top dollar like so many players of his vintage. It has been a remarkably durable career for Boak, who needs only a handful of games to hit 300 matches after averaging 19.7 matches a year across his career.",
   "imagename": "Travis-Boak",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 93,
   "peopleid": 93,
   "name": "Jack Lukosius",
   "club": "Gold Coast",
   "salary": "$600,000-$650,000",
   "bio": "Lukosius is a strange beast, one of football’s most piercing kicks and capable of being the most damaging defender in the league given his height, marking ability, athleticism and capacity to cut opponents apart with that silky right boot. He isn’t a complete player yet but he has plenty of time. He certainly isn’t desperate to race home to Adelaide but like Ben King, he will want to see improvement at the Suns before he signs past his current deal to the end of 2022.",
   "imagename": "Jack-Lukosius",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 94,
   "peopleid": 94,
   "name": "Charlie Dixon",
   "club": "Port Adelaide",
   "salary": "$600,000-$650,000",
   "bio": "Dixon signed a new three-season deal over the summer but not at the kind of extraordinary figures which would limit the Power’s continuing list build. Dixon turns 31 this year so will need to maintain the rage but after crossing from Gold Coast has been at the forefront of the Power’s march up the ladder as a contested marking, long-kicking key position forward.",
   "imagename": "Charlie-Dixon",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 95,
   "peopleid": 95,
   "name": "Brandon Ellis",
   "club": "Gold Coast",
   "salary": "$600,000-$650,000",
   "bio": "Ellis remains an elite kick who capably fulfils his role as a hard-running wingman and flanker who decided to set up his life post-career by taking the money at Gold Coast. The Suns would be more than happy with his return so far despite their continuing issues, with Ellis to pocket just over $3 million for his five years at the Suns despite missing the 2020 flag with the Tigers after his move north.",
   "imagename": "Brandon-Ellis",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 96,
   "peopleid": 96,
   "name": "Reilly O'Brien",
   "club": "Adelaide",
   "salary": "$575,000-$625,000",
   "bio": "O’Brien emerged as a star AFL ruckman like a bolt from the blue after a long apprenticeship and then signed a four-year deal through to 2025. Having won the club’s best-and-fairest last year he would have secured a boost through incentives, with O’Brien now one of the most reliable ruckmen in the game. It has been a seamless transition from the Sam Jacobs era to O’Brien’s emergence.",
   "imagename": "Reilly-OBrien",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 97,
   "peopleid": 97,
   "name": "Lachie Hunter",
   "club": "Western Bulldogs",
   "salary": "$575,000-$625,000",
   "bio": "Yet another of the club’s stars who is heading towards being a Bulldog for life. A five-year contract extension - signed two years ago - ties him to the club until the end of the 2024 season, by which time he will be almost 30.",
   "imagename": "Lachie-Hunter",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 98,
   "peopleid": 98,
   "name": "Jason Johannisen",
   "club": "Western Bulldogs",
   "salary": "$575,000-$625,000",
   "bio": "Has one more year on the contract that he signed the season after he won the 2016 Norm Smith Medal and following some protracted contract haggling. Will be due for a sizeable pay cut after his deal expires at the end of 2022, which might help the Dogs’ salary cap structure.",
   "imagename": "Jason-Johanissen",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 99,
   "peopleid": 99,
   "name": "Mark Blicavs",
   "club": "Geelong",
   "salary": "$575,000-$625,000",
   "bio": "The ultra-reliable tall is one of the AFL’s most flexible players. Chris Scott can put him on the opposition’s best forward or thrust him into the ruck and even the wing in a running role. He has been rewarded by winning two best and fairest gongs as well as a third-place last year. Opted for security when he signed a five-year deal in 2018 tying him to the Cats until 2023.",
   "imagename": "Mark-Blicavs",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 },
 {
   "id": 100,
   "peopleid": 100,
   "name": "Tom Stewart",
   "club": "Geelong",
   "salary": "$575,000-$625,000",
   "bio": "Headed for his third-straight All-Australian jumper, underlining what a super recruit he has been out of South Barwon in the Geelong Football League. The Stephen Wells masterstroke is a brick wall across half back and played one of the best games Chris Scott has seen from a defensive flanker in the after-the-siren win over Western Bulldogs. Provided incredible value all-round.",
   "imagename": "Tom-Stewart",
   "status": "",
   "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    }
 }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js